var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result"},[_c('div',{staticClass:"fail"}),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))]),_c('div',[_c('el-button',{staticClass:"button-repay",on:{"click":_vm.closePage}},[_vm._v("重新下单")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }